//#region src/redux/modal-view/initial-state.ts
var modalViewInitialState = {
	modalViews: null,
	isPending: false,
	isRejected: false,
	errorMessage: ""
};
//#endregion
export { modalViewInitialState };

//# sourceMappingURL=initial-state.js.map